import React from "react";
import Main from "./pages/Main";
import AppToaster from "./components/AppToaster";
import "./components/AppToaster.css";

function App() {
  return (
    <>
      <AppToaster />
      <Main />
    </>
  );
}

export default App;
